import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { Inbox as InboxIcon } from '@mui/icons-material';

/**
 * Honest empty state for an expediente tab that has no captured data yet.
 * Real records start empty — this replaces the old behavior of crashing or
 * showing demo data when a section had nothing.
 */
const ExpedienteEmptyState = ({ title = 'Sin información', hint }) => (
  <Paper elevation={0} sx={{ borderRadius: 3, p: 6, textAlign: 'center', bgcolor: '#FBF5E9' }}>
    <Box
      sx={{
        width: 72, height: 72, borderRadius: '50%', mx: 'auto', mb: 2,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        bgcolor: 'rgba(31,92,61,0.08)', color: '#1F5C3D',
      }}
    >
      <InboxIcon sx={{ fontSize: 36 }} />
    </Box>
    <Typography variant="h6" fontWeight={700} gutterBottom>{title}</Typography>
    <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 460, mx: 'auto' }}>
      {hint || 'Aún no hay datos capturados en esta sección. Usa el botón de captura para registrarlos.'}
    </Typography>
  </Paper>
);

export default ExpedienteEmptyState;
